export const gameColors = {
  Yellow: 0,
  Blue: 1,
  Red: 2,
  Green: 3,
};

export const gameColorsCodes = {
  0: 'yellow',
  1: 'blue',
  2: 'red',
  3: 'green',
};

export const gameColorsOdd = {
  red: 3,
  blue: 2,
  green: 5,
  yellow: 50,
};
